module.exports = __webpack_public_path__ + "img/8.a03619e1.png";